import api from "../axiosIntercepture";

export const getGlobalOptions = async (type) => {
    try {
        const response = await api.post("global/getgloabldata", {
            type,
            "countryCode": "IN"
        });
        return response.data?.data?.enums;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}